import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as MDICONS from '@material-ui/icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { clearProjectId, createProject, setCurrentProjectId } from '../../../../store/actions/projectActions';
import Loader from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes';

const formLabelStyle = {
    fontSize: "15px",
    fontWeight: "bold",
};

const instTextStyle = { textAlign: "start", padding: "10px" };

class CreateProjectForm extends Component {

    constructor(props) {
        super()
        this.state = {
            projectTitle: "",
            email: "",
            phone: "",
            selectedFiles: [],
            url: '',
        }

    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log("CREATING PROJECT...");

        var selectedFiles = this.state.selectedFiles;
        const { userData, companyData } = this.props;
        const projectData = {
            projectTitle: this.state.projectTitle ?? "",
            email: this.state.email ?? "",
            phone: this.state.phone ?? "",
        };

        this.props.createProject(userData, companyData, projectData, selectedFiles);
    }

    onChangeHandler = (e) => {
        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var files = e.target.files;
            this.setState(() => ({ selectedFiles: files }));
        }
    }

    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 100) {
            const msg = 'Only 100 pdf files can be uploaded at a time'
            e.target.value = null
            toast.error(msg)
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            e.target.value = null
            toast.error(err)
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['application/pdf']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            toast.error(err)
            return false;
        }
        return true;
    }

    /// TODO: NEED TO REVISIT (ZAIN)
    componentDidMount() {
        this.props.clearProjectId();
    }

    render() {
        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { companyData, project,commons } = this.props;
        const { isProjectCreating, isFilesAdded, isProjectCreated, proid } = project;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isProjectCreated ?
            (<React.Fragment>
                <Link to={ROUTES.IND_PROJECT} className="btn btn-dark btn-md" onClick={() => this.props.setCurrentProjectId(proid)}>
                    Visit project page
                </Link>
                <br></br>
                <Link to={ROUTES.HOME_PROJECTS}>Go back</Link>
            </React.Fragment>)
            :
            (isProjectCreating ?
                (<React.Fragment>
                    <Loader
                        type="TailSpin"
                        color={this.props.themeColors.themeColor}
                        height={30}
                        width={30}
                    />
                    <br></br>
                    <p style={textStyle}>{(isFilesAdded ? (<p>Uploading files...</p>) : (<p>Creating {commons.project}...</p>))}</p>
                    <br></br>
                </React.Fragment>)
                :
                (<button className="btn btn-dark btn-md" type="submit" onClick={this.handleSubmit}>Create this {commons.project}</button>));

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        return (
            <div className="row">
                {/* col 3 end */}
                <div className="col">
                    <div className="container py-3">
                        <div className="card p-3">
                            {/* <h5 className="card-header" style={{ fontWeight: "bold" }}></h5> */}
                            <div className="card-body">
                                <form onSubmit={this.handleSubmit}>

                                    {/* ProjectTitle */}
                                    <div className="form-group text-left pb-3">
                                        <label htmlFor="projectTitle" style={formLabelStyle}>Project title</label>
                                        <input type="text" className="form-control bg-light" id="projectTitle" onChange={this.handleChange} required disabled={isProjectCreated} />
                                    </div>

                                    {/* Email Address */}
                                    <div className="form-group text-left pb-3">
                                        <label htmlFor="email" style={formLabelStyle}>Email address</label>
                                        <input type="text" className="form-control bg-light" id="email" onChange={this.handleChange} required disabled={isProjectCreated} />
                                    </div>

                                    {/* Phone No */}
                                    <div className="form-group text-left pb-3">
                                        <label htmlFor="phone" style={formLabelStyle}>Company's phone</label>
                                        <input type="tel" className="form-control bg-light" id="phone" placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" onChange={this.handleChange} required disabled={isProjectCreated} />
                                    </div>

                                    {/* File upload button */}
                                    <div className="form-group text-left pb-3">
                                        <label style={formLabelStyle}>Attach files (PDF only</label>
                                        <br />
                                        <input type="file" className="file" multiple onChange={this.onChangeHandler} style={{ fontWeight: "bold", fontSize: "18px" }} disabled={isProjectCreating || isProjectCreated} />
                                    </div>

                                    {/* project submit button */}
                                    <div className="form-group text-center p-5">
                                        <div className="align-items-center">
                                            {relevantSubmitComponent}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> {/* col 8 end */}
                <div className="col">
                    <div className="container py-3">
                        <div className="card p-3">
                            <div className="card-header bg-white p-0">
                                <div className="row">
                                    <div className="col-8">
                                        <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Terms and conditions</p>
                                    </div>
                                    <div className="col-4">
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <ol>
                                    <li style={instTextStyle}>You must comply with your company's terms and our terms.</li>
                                    <li style={instTextStyle}>You must note that you can be removed by either your company or by AssetTag on any misconduct.</li>
                                    <li style={instTextStyle}>If you are found distributing QR code without permission and compliance.</li>
                                </ol>
                                <br />
                                <br />
                                <p><b>In short, save your account from getting suspended!</b></p>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
                {/* col 3 end */}
                {/* row end */}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        auth: state.auth,
        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        project: state.project,
        commons:state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createProject: (userData, companyData, projectData, selectedFiles) => dispatch(createProject(userData, companyData, projectData, selectedFiles)),
        setCurrentProjectId: (proid) => dispatch(setCurrentProjectId(proid)),
        clearProjectId: () => dispatch(clearProjectId()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProjectForm);
